import { useSuspenseQuery } from "@tanstack/react-query"
import { createFileRoute } from "@tanstack/react-router"
import { z } from "zod"

import { PageHeader } from "@/components/common/page-header"
import { RiskFactorAffected } from "@/features/risk/components/risk-factor-affected"
import { RiskFactorSummary } from "@/features/risk/components/risk-factor-summary"
import { riskQueries } from "@/queries/risk"

export const Route = createFileRoute(
  "/$organisation/_authenticated/_organisation/_main/risk/factors/$factorKey/"
)({
  validateSearch: z.object({ q: z.string().optional() }),
  loader: ({ context, params }) =>
    context.queryClient.ensureQueryData(riskQueries.factor(params.factorKey)),
  component: RiskFactorPage,
})

function RiskFactorPage() {
  const { factorKey } = Route.useParams()
  const { data } = useSuspenseQuery(riskQueries.factor(factorKey))
  const { q } = Route.useSearch()
  const navigate = Route.useNavigate()

  return (
    <>
      <PageHeader
        title={data.label}
        back={{ label: "Risk", to: "/$organisation/risk" }}
      />
      <div className="flex flex-col gap-10">
        <RiskFactorSummary factorKey={factorKey} />
        <RiskFactorAffected
          factorKey={factorKey}
          search={q}
          onSearch={(search) =>
            void navigate({ replace: true, search: { q: search } })
          }
        />
      </div>
    </>
  )
}
